import React from 'react';
import styled from '@emotion/styled';
import CardConfiguracaoUnidade from '../../../../components/CardConfiguracaoUnidade';
import { filtroProcedimentoOptions, TipoCancelamentoOptions } from './constants';

const Agendamento = ({ venda, configuracaoUnidade, onChange, disabled }) => {
  return (
    <Container>
      <GridContainer>
        <CardConfiguracaoUnidade
          title="Detalhes no agendamento"
          configuracaoUnidade={configuracaoUnidade}
          onChange={onChange}
          disabled={disabled}
          fields={[
            { value: 'marcarFaltososAutomaticamente', label: 'Marcar faltosos automaticamente?', type: 'switch' },
            {
              label: 'Bloquear alterações nos agendamentos após quantas horas?',
              name: 'numeroHorasBloqueioAgendamento',
              value: 'numeroHorasBloqueioAgendamento',
              type: 'input',
            },
            {
              label: 'Paciente pode confirmar o agendamento em até quantas horas?',
              name: 'horasPermiteConfirmarAgendamento',
              value: 'horasPermiteConfirmarAgendamento',
              type: 'input',
            },
            { value: 'enviaMensagemConfirmacaoEmail', label: 'Enviar mensagem de confirmação por e-mail?', type: 'switch' },
            { value: 'validaAgendamentoMesmoHorario', label: 'Validar se há agendamentos do mesmo paciente para médicos diferentes no mesmo horário?', type: 'switch' },
            { value: 'utilizaEnderecoMensagemAgendamento', label: 'Utiliza o endereço da clínica na mensagem de confirmação de agendamento?', type: 'switch' },
            { value: 'confirmaPresencaAgendamento', label: 'Confirmar presença no agendamento?', type: 'switch' },
            { value: 'utilizaConvenioAgendamento', label: 'Permitir agendamentos apenas com convênio selecionado?', type: 'switch' },
            { value: 'permiteAtualizarAgendamentoSituacaoFuturo', label: 'Permite atualizar situação agendamentos futuros?', type: 'switch' },
            { value: 'visualizarAgendamentoRede', label: 'Visualizar histórico de agendamentos do paciente na rede?', type: 'switch' },
            { value: 'cadastroRapidoAgendamento', label: 'Utiliza cadastro rápido para agendamento?', type: 'switch' },
            { value: 'filtroProcedimento', label: 'Filtro dos procedimentos', type: 'multiSelect', options: filtroProcedimentoOptions },
            { value: 'utilizaEtiquetaIdentificacao', label: 'Utiliza etiqueta de identificação para agendamento?' },
            { value: 'faturamentoObrigatorio', label: 'Utiliza faturamento obrigatório?' },
            { value: 'preencherTipoConsulta', label: 'Utiliza tipo consulta obrigatório?' },
            { value: 'utilizaDuracaoProcedimentosTipoConsulta', label: 'Utiliza duração dos procedimentos e tipo atendimento?' },
            { value: 'utilizaMotivoDeCancelamentoDoAgendamento', label: 'Motivo de cancelamento', type: 'select', optionsSelect: TipoCancelamentoOptions },
            { value: 'utilizaReagendamento', label: 'Utiliza obrigatoriedade de reagendamento?' },
            { value: 'mostrarApenasProcedimentoOdontologicoFaturado', label: 'Exibir somente procedimentos odontológicos faturados?' },
          ]}
        />

        <MinorCards>
          <CardConfiguracaoUnidade
            title="Notificação de agendamento"
            configuracaoUnidade={configuracaoUnidade}
            onChange={onChange}
            disabled={disabled}
            fields={[
              { value: 'enviaConfirmacaoDoisDiasAntes', label: 'Confirmar dois dias antes?', type: 'switch' },
              { value: 'enviaConfirmacaoUmDiasAntes', label: 'Confirmar um dia antes?', type: 'switch' },
              { value: 'enviaConfirmacaoUmaHoraAntes', label: 'Confirmar uma hora antes?', type: 'switch' },
              { value: 'enviaConfirmacaoAntecipaFinalDeSemana', label: 'Confirmar antes do fim de semana?', type: 'switch' },
            ]}
          />
          <CardConfiguracaoUnidade
            title="Configurações da agenda"
            configuracaoUnidade={configuracaoUnidade}
            onChange={onChange}
            disabled={disabled}
            fields={[
              { value: 'mostrarHorariosBloqueados', label: 'Mostrar horários bloqueados pela configuração do horário de atendimento?', type: 'switch' },
              { value: 'mostrarObservacaoImpressaoAgenda', label: 'Mostrar o campo de observação na impressão da agenda?', type: 'switch' },
            ]}
          />
        </MinorCards>
      </GridContainer>

      <FullWidth>
        <CardConfiguracaoUnidade
          title="Notificação de sala"
          configuracaoUnidade={configuracaoUnidade}
          onChange={onChange}
          disabled={disabled}
          fields={[
            { value: 'enviaConfirmacaoDoisDiasAntesSala', label: 'Confirmar dois dias antes?', type: 'switch' },
            { value: 'enviaConfirmacaoUmDiasAntesSala', label: 'Confirmar um dia antes?', type: 'switch' },
            { value: 'enviaConfirmacaoUmaHoraAntesSala', label: 'Confirmar uma hora antes?', type: 'switch' },
          ]}
        />
      </FullWidth>
    </Container>
  );
};

export default Agendamento;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const MinorCards = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

const FullWidth = styled.div`
  width: 100%;
`;
